import { computed, reactive } from "@nuxtjs/composition-api";
const state = reactive({
  isCartSidebarOpen: false,
  isWishlistSidebarOpen: false,
  isLoginModalOpen: false,
  isNewsletterModalOpen: false,
  isCategoryGridView: true,
  isWishlistGridView: true,
  isFilterSidebarOpen: false,
  isMobileMenuOpen: false,
  isSearchOpen: false
});
function useUiState() {
  const toggleMobileMenu = () => {
    state.isMobileMenuOpen = !state.isMobileMenuOpen;
    if (document) {
      if (state.isMobileMenuOpen) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    }
  };
  const toggleCartSidebar = () => {
    if (state.isMobileMenuOpen)
      toggleMobileMenu();
    state.isCartSidebarOpen = !state.isCartSidebarOpen;
  };
  const toggleWishlistSidebar = () => {
    if (state.isMobileMenuOpen)
      toggleMobileMenu();
    state.isWishlistSidebarOpen = !state.isWishlistSidebarOpen;
  };
  const toggleLoginModal = () => {
    if (state.isMobileMenuOpen)
      toggleMobileMenu();
    state.isLoginModalOpen = !state.isLoginModalOpen;
  };
  const toggleNewsletterModal = () => {
    state.isNewsletterModalOpen = !state.isNewsletterModalOpen;
  };
  const changeToCategoryGridView = () => {
    state.isCategoryGridView = true;
  };
  const changeToCategoryListView = () => {
    state.isCategoryGridView = false;
  };
  const changeToWishlistGridView = () => {
    state.isWishlistGridView = true;
  };
  const changeToWishlistListView = () => {
    state.isWishlistGridView = false;
  };
  const toggleFilterSidebar = () => {
    state.isFilterSidebarOpen = !state.isFilterSidebarOpen;
  };
  const showSearch = () => {
    state.isSearchOpen = true;
    if (document) {
      document.body.classList.add("no-scroll");
    }
  };
  const hideSearch = () => {
    state.isSearchOpen = false;
    if (document) {
      document.body.classList.remove("no-scroll");
    }
  };
  const toggleSearch = () => {
    if (state.isSearchOpen) {
      hideSearch();
    } else {
      showSearch();
    }
  };
  return {
    isMobileMenuOpen: computed(() => state.isMobileMenuOpen),
    isCartSidebarOpen: computed(() => state.isCartSidebarOpen),
    isWishlistSidebarOpen: computed(() => state.isWishlistSidebarOpen),
    isLoginModalOpen: computed(() => state.isLoginModalOpen),
    isNewsletterModalOpen: computed(() => state.isNewsletterModalOpen),
    isCategoryGridView: computed(() => state.isCategoryGridView),
    isWishlistGridView: computed(() => state.isWishlistGridView),
    isFilterSidebarOpen: computed(() => state.isFilterSidebarOpen),
    isSearchOpen: computed(() => state.isSearchOpen),
    toggleMobileMenu,
    toggleCartSidebar,
    toggleWishlistSidebar,
    toggleLoginModal,
    toggleNewsletterModal,
    changeToCategoryGridView,
    changeToCategoryListView,
    changeToWishlistGridView,
    changeToWishlistListView,
    toggleFilterSidebar,
    toggleSearch,
    showSearch,
    hideSearch
  };
}
var useUiState_default = useUiState;
export * from "./useUiState";
export {
  useUiState_default as default,
  useUiState
};
